import ScoreCircle from "./ScoreCircle";
export default ScoreCircle;
